import {
  applyContextOptions,
  restoreContextOptions,
} from "@tradingApp/helpers/canvas/contextOptions";
import {
  applyTranslate,
  restoreTranslate,
} from "@tradingApp/helpers/canvas/translate";
import type { BasicDrawOptions } from "@tradingApp/helpers/canvas/types";

interface Options {
  context: CanvasRenderingContext2D;
  x: number;
  y: number;
  width: number;
  height: number;
  radius?: number;
  fill?: boolean;
  stroke?: boolean;
  contextOptions?: BasicDrawOptions["contextOptions"];
  translateX?: number;
  translateY?: number;
}

export function drawRoundRect(options: Options): void {
  const {
    context,
    x,
    y,
    width,
    height,
    radius = 5,
    fill = true,
    stroke = true,
  } = options;

  const radiusCorners = { tl: radius, tr: radius, br: radius, bl: radius };
  applyTranslate(options);
  applyContextOptions(options);
  context.save();
  context.beginPath();
  context.moveTo(x + radiusCorners.tl, y);
  context.lineTo(x + width - radiusCorners.tr, y);
  context.quadraticCurveTo(x + width, y, x + width, y + radiusCorners.tr);
  context.lineTo(x + width, y + height - radiusCorners.br);

  context.quadraticCurveTo(
    x + width,
    y + height,
    x + width - radiusCorners.br,
    y + height,
  );

  context.lineTo(x + radiusCorners.bl, y + height);
  context.quadraticCurveTo(x, y + height, x, y + height - radiusCorners.bl);
  context.lineTo(x, y + radiusCorners.tl);
  context.quadraticCurveTo(x, y, x + radiusCorners.tl, y);
  context.closePath();

  if (fill) {
    context.fill();
  }

  if (stroke) {
    context.stroke();
  }

  context.restore();
  restoreContextOptions(options);
  restoreTranslate(options);
}
